<template>
  <div class="home-page-box">
    <!-- 顶部 -->
    <homeHead :pages="notice" @childEvent="handleChildEvent" :isRouterIndex="'1'"></homeHead>

    <div class="home-page-content">

      <!-- 文章 -->
      <div class="home-app">
        <div class="home-card">
          <div class="home-card__header">
            <div class="home-card__header__title">
              <img src="./../../../../assets/homeNew/yyfw-icon.png" />
              <span>通知公告</span>
            </div>

          </div>
          <div class="home-card__content border-radius__16  overflow-auto backgroundTr">
            <div class="home-card__content--wrapper ">

              <!-- 应用 -->

              <div class="app-list__content ">
                <div class="article-padding-box" v-if="noticeList.length > 0">
                  <div class="article-list-box hairline-bottom" v-for="(item,index) in noticeList" :key="index" @click="goNotice(item)">
                    <div class="icon"></div>
                    <div class="title">
                      {{item.title}}
                    </div>
                    <div class="time">
                      {{item.releaseTime  | analyseTime('1')}}
                    </div>
                  </div>

                  <div class="page-apply">
                    <Paging :totalNumber="zongtiaoshu" :pageShowTotal="pageSize" :showActivePageIndex="pageNum" @callBack="handleCurrentChange" :isShowIndex="'1'"></Paging>
                  </div>
                </div>
                <div class="no-wrap" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import homeFooter from '../../component/homeFooter.vue'
import homeSearch from '../../component/homeSearch.vue'
import { analyseTime } from '../../../../components/filter'
import { getArticleListByType } from '../../../../api/api.p'
import { dateFormat } from '../../../../libs/util'
import axios from 'axios';
import Paging from '../../page-comn/Paging.vue';

export default {
  props: {},
  data () {
    return {
      notice: 'notice',
      noticeList: [],

      userInfo: {},
      pageNum: 1,
      pageSize: 10,
      zongtiaoshu: 0,
      titles: '',
    }
  },
  filters: {

  },
  components: {
    homeHead,
    homeFooter,
    homeSearch,
    Paging,
  },
  created () {
  },
  mounted () {


    this.getArticleListByTypeFun()


  },
  methods: {
    handleChildEvent (data) {
      // console.log(data); // 处理从子组件接收到的数据
      this.titles = data;
      this.pageNum = 1;

      this.getArticleListByTypeFun();

      // 可以在这里调用其他方法或执行其他操作
    },
    handleCurrentChange (val, index) {
      this.pageNum = val;
      this.pageSize = index;
      this.getArticleListByTypeFun();
    },
    goNotice (item) {
      let ids = JSON.parse(JSON.stringify(item))
      this.$router.push({
        path: '/noticeDetail',
        query: {
          articleId: ids.id,
        }
      })
    },
    async getArticleListByTypeFun () {

      let param = {
        type: '通知公告',
        title: this.titles,
        "pageNumber": this.pageNum,
        "numPerPage": this.pageSize,
      }
      const res = await getArticleListByType(param);
      if (res) {

        if (res.meta.code == 0) {
          this.noticeList = res.data.records;
          this.zongtiaoshu = JSON.parse(res.data.total);
        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

  },
}
</script>

<style lang="less" scoped>
@import './search.less';
</style>


